import React from "react";
import type { WarmupPhase } from "../hooks/useWarmup";

function VelaroLogo({ size = 80 }: { size?: number }) {
  return (
    <svg
      viewBox="0 0 111.5 95"
      width={size}
      height={size * (95 / 111.5)}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="#2FBF71"
        d="M48.1,91.7C-5.2,54.5,18,30.4,54.1,29C70.5,28.3,71,1.3,53.5,3.5C36.2,5.7-1,20.2,5.8,46.7C11.1,66.8,35.7,87.2,48.1,91.7z"
      />
      <path
        fill="#4C75AB"
        d="M63.4,3.3c53.3,37.1,30.1,61.2-6,62.7c-16.3,0.7-16.8,27.7,0.6,25.5c17.2-2.2,54.5-16.8,47.7-43.2C100.5,28.1,75.8,7.8,63.4,3.3z"
      />
      <circle cx="55.8" cy="47.5" r="6.5" fill="#4C75AB" />
    </svg>
  );
}

export default function Warmup({ phase }: { phase: WarmupPhase }) {
  return (
    <>
      <style>{`
        @keyframes v-pulse {
          0%, 100% { opacity: 1; transform: scale(1); }
          50% { opacity: 0.85; transform: scale(0.97); }
        }
        @keyframes v-shimmer {
          0% { transform: translateX(-100%); }
          100% { transform: translateX(350%); }
        }
        @keyframes v-dot-1 {
          0%, 20% { opacity: 0; }
          30%, 100% { opacity: 1; }
        }
        @keyframes v-dot-2 {
          0%, 40% { opacity: 0; }
          50%, 100% { opacity: 1; }
        }
        @keyframes v-dot-3 {
          0%, 60% { opacity: 0; }
          70%, 100% { opacity: 1; }
        }
        .v-warmup-root {
          position: fixed;
          inset: 0;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          background: #f9fafb;
          gap: 24px;
          font-family: 'Rubik', sans-serif;
          z-index: 99999;
          opacity: 1;
          transition: opacity 500ms ease-out;
        }
        .v-warmup-root.v-fading {
          opacity: 0;
        }
        .v-warmup-logo {
          animation: v-pulse 2.5s ease-in-out infinite;
        }
        .v-warmup-text {
          color: #6b7280;
          font-size: 15px;
          font-weight: 400;
          letter-spacing: 0.01em;
          display: flex;
          align-items: baseline;
          gap: 0;
        }
        .v-warmup-dots {
          display: inline-flex;
          width: 1.5em;
          margin-left: 1px;
        }
        .v-warmup-dots span {
          animation-duration: 1.4s;
          animation-iteration-count: infinite;
          opacity: 0;
        }
        .v-warmup-dots span:nth-child(1) { animation-name: v-dot-1; }
        .v-warmup-dots span:nth-child(2) { animation-name: v-dot-2; }
        .v-warmup-dots span:nth-child(3) { animation-name: v-dot-3; }
        .v-warmup-bar-track {
          width: 160px;
          height: 3px;
          background: #e5e7eb;
          border-radius: 3px;
          overflow: hidden;
        }
        .v-warmup-bar-fill {
          width: 40%;
          height: 100%;
          background: linear-gradient(90deg, #4C75AB, #2FBF71);
          border-radius: 3px;
          animation: v-shimmer 1.4s ease-in-out infinite;
        }
      `}</style>
      <div className={`v-warmup-root${phase === "fading" ? " v-fading" : ""}`}>
        <div className="v-warmup-logo">
          <VelaroLogo size={72} />
        </div>
        <span className="v-warmup-text">
          Preparing your workspace
          <span className="v-warmup-dots">
            <span>.</span><span>.</span><span>.</span>
          </span>
        </span>
        <div className="v-warmup-bar-track">
          <div className="v-warmup-bar-fill" />
        </div>
      </div>
    </>
  );
}
